<template>
  <div id="mrequest">
    <section>
      <div class="container my-3">
        <div class="row justify-content-center">
          <h3>문의내역</h3>

          <!-- 문의들 구분 탭 -->
          <div class="mr-tap">
            <button type="button" class="tab-btn" :class="{ active: reqFlag === 'one' }" @click="changeIquiry('one')">1:1 문의</button>
            <button type="button" class="tab-btn" :class="{ active: reqFlag === 'item' }" @click="changeIquiry('item')">상품문의</button>
            <button type="button" class="tab-btn" :class="{ active: reqFlag === 'estimate' }" @click="changeIquiry('estimate')">견적문의</button>
          </div>

          <!-- 1:1 pc-->
          <div class="row mr-cont pc" v-if="this.reqFlag == 'one'">
            <p class="count-line">총 <b>{{ this.reqList.length }}</b>건</p>
            <table class="table">
              <thead>
                <tr>
                  <th class="col-2">상태</th>
                  <th class="col-2">유형</th>
                  <th class="col-4">제목</th>
                  <th class="col-2">작성일</th>
                  <th class="col-2">답변</th>
                </tr>
              </thead>
              <tbody>
                <tr :key="j" v-for="(ca, j) in reqList">
                  <td><span class="tag">{{ ca.status }}</span></td>
                  <td>{{ ca.cat }}</td>
                  <td class="title-cell">
                    <a @click="goToCustomerAsk_client(ca.askCode, ca.pdtCode);" class="row-link">
                      {{ ca.reqTitle }}
                    </a>
                  </td>
                  <td class="muted">{{ this.getDateFormat(ca.reqDate) }}</td>
                  <td>
                    <span class="badge" :class="ca.answerId == undefined ? 'badge-wait' : 'badge-done'">
                      {{ ca.answerId == undefined ? '답변대기' : '답변완료' }}
                    </span>
                  </td>
                </tr>
                <tr v-if="reqList.length === 0">
                  <td colspan="5" class="empty-row">등록된 1:1 문의가 없습니다.</td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- 1:1 모바일-->
          <div class="row mr-cont mobile" v-if="this.reqFlag == 'one'">
            <p class="count-line">총 <b>{{ this.reqList.length }}</b>건</p>
            <div class="m-card" :key="j" v-for="(ca, j) in reqList">
              <div class="m-card-top">
                <span class="tag">{{ ca.status }}</span>
                <span class="badge" :class="ca.answerId == undefined ? 'badge-wait' : 'badge-done'">
                  {{ ca.answerId == undefined ? '답변대기' : '답변완료' }}
                </span>
              </div>
              <a @click="goToCustomerAsk_client(ca.askCode, ca.pdtCode);" class="row-link m-title">
                {{ ca.reqTitle }}
              </a>
              <p class="m-sub">{{ ca.cat }} · {{ this.getDateFormat(ca.reqDate) }}</p>
            </div>
            <p class="empty-row" v-if="reqList.length === 0">등록된 1:1 문의가 없습니다.</p>
          </div>

          <!-- 문의하기 버튼 -->
          <div class="mt-5 row justify-content-center" v-if="this.reqFlag == 'one'">
            <button class="btn go col-8 col-lg-3 mx-2" @click="goToCustomerAsk()">1:1 문의하기</button>
          </div>

          <!-- 상품문의 pc -->
          <div class="row mr-cont pc" v-if="this.reqFlag == 'item'">
            <p class="count-line">총 <b>{{ this.reqList_inq.length }}</b>건</p>
            <table class="table">
              <thead>
                <tr>
                  <th class="col-1">상태</th>
                  <th class="col-1">유형</th>
                  <th class="col-3">제목</th>
                  <th class="col-5">상품</th>
                  <th class="col-1">작성일</th>
                  <th class="col-1">답변</th>
                </tr>
              </thead>
              <tbody>
                <tr :key="j" v-for="(item, j) in reqList_inq">
                  <td><span class="tag">{{ item.status }}</span></td>
                  <td>{{ item.cat }}</td>
                  <td class="title-cell">
                    <a @click="goToInquiryDetail_client(item.iqCode);" class="row-link">
                      {{ item.reqTitle }}
                    </a>
                  </td>
                  <td>
                    <a @click="goToProductDetail(item.pdtCode);" class="pdt-link">
                      {{ item.pdtNameKor }}
                    </a>
                  </td>
                  <td class="muted">{{ this.getDateFormat(item.reqDate) }}</td>
                  <td>
                    <span class="badge" :class="item.ansId == undefined ? 'badge-wait' : 'badge-done'">
                      {{ item.ansId == undefined ? '답변대기' : '답변완료' }}
                    </span>
                  </td>
                </tr>
                <tr v-if="reqList_inq.length === 0">
                  <td colspan="6" class="empty-row">등록된 상품문의가 없습니다.</td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- 상품문의 모바일 -->
          <div class="row mr-cont mobile" v-if="this.reqFlag == 'item'">
            <p class="count-line">총 <b>{{ this.reqList_inq.length }}</b>건</p>
            <div class="m-card" :key="j" v-for="(item, j) in reqList_inq">
              <div class="m-card-top">
                <span class="tag">{{ item.status }}</span>
                <span class="badge" :class="item.ansId == undefined ? 'badge-wait' : 'badge-done'">
                  {{ item.ansId == undefined ? '답변대기' : '답변완료' }}
                </span>
              </div>
              <a @click="goToInquiryDetail_client(item.iqCode);" class="row-link m-title">
                {{ item.reqTitle }}
              </a>
              <a @click="goToProductDetail(item.pdtCode);" class="pdt-link m-pdt">
                {{ item.pdtNameKor }}
              </a>
              <p class="m-sub">{{ item.cat }} · {{ this.getDateFormat(item.reqDate) }}</p>
            </div>
            <p class="empty-row" v-if="reqList_inq.length === 0">등록된 상품문의가 없습니다.</p>
          </div>

          <!-- 견적문의 pc -->
          <div class="row mr-cont pc" v-if="this.reqFlag == 'estimate'">
            <p class="count-line">총 <b>{{ this.reqList_quo.length }}</b>건</p>
            <table class="table">
              <thead>
                <tr>
                  <th class="col-2">상태</th>
                  <th class="col-2">유형</th>
                  <th class="col-4">제목</th>
                  <th class="col-2">작성일</th>
                  <th class="col-2">답변</th>
                </tr>
              </thead>
              <tbody>
                <tr :key="j" v-for="(estimate, j) in reqList_quo">
                  <td><span class="tag">{{ estimate.status }}</span></td>
                  <td>{{ estimate.pCategory }}</td>
                  <td class="title-cell">
                    <a @click="goToQuotationDetail_client(estimate.qCode, estimate.seqReq);" class="row-link">
                      {{ estimate.reqTitle }}
                    </a>
                  </td>
                  <td class="muted">{{ this.getDateFormat(estimate.reqDate) }}</td>
                  <td>
                    <span class="badge" :class="estimate.ansId == undefined ? 'badge-wait' : 'badge-done'">
                      {{ estimate.ansId == undefined ? '답변대기' : '답변완료' }}
                    </span>
                  </td>
                </tr>
                <tr v-if="reqList_quo.length === 0">
                  <td colspan="5" class="empty-row">등록된 견적문의가 없습니다.</td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- 견적문의 모바일 -->
          <div class="row mr-cont mobile" v-if="this.reqFlag == 'estimate'">
            <p class="count-line">총 <b>{{ this.reqList_quo.length }}</b>건</p>
            <div class="m-card" :key="j" v-for="(estimate, j) in reqList_quo">
              <div class="m-card-top">
                <span class="tag">{{ estimate.status }}</span>
                <span class="badge" :class="estimate.ansId == undefined ? 'badge-wait' : 'badge-done'">
                  {{ estimate.ansId == undefined ? '답변대기' : '답변완료' }}
                </span>
              </div>
              <a @click="goToQuotationDetail_client(estimate.qCode, estimate.seqReq);" class="row-link m-title">
                {{ estimate.reqTitle }}
              </a>
              <p class="m-sub">{{ estimate.pCategory }} · {{ this.getDateFormat(estimate.reqDate) }}</p>
            </div>
            <p class="empty-row" v-if="reqList_quo.length === 0">등록된 견적문의가 없습니다.</p>
          </div>

          <div class="mt-5 row justify-content-center" v-if="this.reqFlag == 'estimate'">
            <button class="btn go col-8 col-lg-3 mx-2" @click="goToRequestQuoDetail()">견적문의하기</button>
          </div>

        </div>
      </div>
    </section>
  </div>
</template>

<script>
import moment from 'moment';
//import { getAvailPoint } from "../assets/js/commonFunctions.js"
export default {
  data() {
    return {
      reqFlag: "", //문의플래그
      userInfo: [], //유저정보

      //1:1문의관련
      reqList: [], //1:1문의

      //상품문의관련
      reqList_inq: [],      

      //견적관련
      reqList_quo: [],
      
      resUserPoint: [],
      availPoint: 0, // 사용자 가용포인트

      rProc: [], //프로세스레벨

      //예약관련
      reqListReqRes: [], //접수중 예약
      reqListEvt: [], //마이행사
      reqListAll: [], //전체
      resName: "", //상품, 행사명 (통합) 
      dFlag: "", //시기구분플래그
    };
  },
  created(){
    if (this.$store.state.user.handlerId != undefined) {
      this.user = this.$store.state.user.handlerId
    }
    else if (this.$store.state.user.email != undefined) {
      this.user = this.$store.state.user.email
    }
    else {
      this.user = ""
    }
    
    this.reqFlag = this.$route.query.askCode || "one";
  
    //console.log("user:",this.$store.state.user);

    const today_tmp = moment();
    let today1 = moment([today_tmp.year(), today_tmp.month(), today_tmp.date()]);
    this.today = today1.format("YYYY-MM-DD")

    //회원정보
    this.getUserInfo();

    //1:1문의리스트
    this.getCustomerAskList(this.user.email)

    //상품문의리스트
    this.getInquiryProduct(this.user.email)

    //견적관련
    this.getRequestQuotationList(this.user.email)


    //카카오알림용 인적정보
    if(this.user.joinFlag === "K" || this.user.joinFlag === "E" || this.userInfo.joinFlag == 'H')
    {
      this.k_name = (!this.user.nickname) ? "" : this.user.nickname;

      let kakaoPhone = ""
      if(this.user.phone != undefined &&this.user.phone.charAt(0) === '+')
      {
        //console.log("kakao:",this.user.phone.replace("+82 ", "0"))
        kakaoPhone = this.user.phone.replace("+82 ", "0")
      }
      this.k_tel = (!this.user.phone) ? "" : kakaoPhone.replace(/-/g,""); //-제거       
    }
    else
    {
      this.k_name = this.user.name;
      this.k_tel = (!this.user.mobile) ? "" : this.user.mobile.replace(/-/g,""); //-제거
    }
    //console.log("k_name:",this.k_name, "k_tel:",this.k_tel)
  },
  computed: {
    user() {
      return this.$store.state.user;
    }
  },  
  mounted() {
    if(document.referrer == "") {
      this.$swal.fire('', '적절하지 않은 페이지 접근입니다.', 'error');
      this.$router.push({path: '/'});
    }

    //비회원 접근 시 대응처리
    if(!this.$store.state.user.email || this.$store.state.user.email == undefined) 
    {
      var swal = require('sweetalert2');
      swal.fire({
        title: '',
        text: '로그인 후 이용해주세요.',
        icon: 'warning'
      });
      this.$router.push({path: '/'});
    }
  },  
  methods: {
    // 숫자 3자리마다 콤마 찍기
    getCurrencyFormat(value) {
      return this.$currencyFormat(value);
    },
    getDateFormat(date) {
      return this.$dateFormat(date);
    },

    async getUserInfo() 
    {
      let userInfo = await this.$api("/api/checkMemEmail", {param: [this.user.email]});
      if(userInfo.length > 0) {
        this.userInfo = userInfo[0];
      }
    },

    //문의내용 화면변경
    changeIquiry(param){
      this.reqFlag = param
    },

    //1:1문의
    async getCustomerAskList(uId) {
      let reqList = await this.$api("/api/customerAskList_myPage", {param: uId});
      if(reqList.length > 0) {
        this.reqList = reqList;
      }
      //console.log("reqList:",this.reqList);
    },

    //1:1문의 상세정보
    goToCustomerAsk_client(code, pCode) {  //code: 질문번호
      let pdtCode = (pCode == undefined) ? "" : pCode;
      this.$router.push({path: '/customerAsk_client', query:{askCode: code, pCode: pdtCode}});
    },    
    //1:1문의 바로가기
    goToCustomerAsk() {
      this.$router.push({path: '/customerAsk'});
    },

    //상품문의
    async getInquiryProduct(uId) {
      let reqList_inq = await this.$api("/api/inquiryProcudt_myPage", {param: uId});
      if(reqList_inq.length > 0) {
        this.reqList_inq = reqList_inq;
      }
      //console.log("reqList_inq:",this.reqList_inq);
    },
    //상품문의상세
    goToInquiryDetail_client(code) {  //code: 질문번호
      this.$router.push({path: '/inquiryDetail_client', query:{iqCode: code}});
    },
    goToProductDetail(pdtCode){
      let salesRoute = pdtCode.charAt(0)
      this.$router.push({path: '/detail', query:{productId: pdtCode, salesRoute: salesRoute}});
    },

    //견적문의
    async getRequestQuotationList(uId) 
    {
      let reqList_quo = await this.$api("/api/reqQuotationList_myPage", {param: uId});
      if(reqList_quo.length > 0) {
        this.reqList_quo = reqList_quo;
      }
      //console.log("reqList_quo:",this.reqList_quo);
    },
    //문의상세
    goToQuotationDetail_client(code, seq) {  //code: 질문번호
      this.$router.push({path: '/QuotationDetail_client', query:{qtCode: code, seqReq: seq}});
    },    
    //견적문의 바로가기
    goToRequestQuoDetail() {
      this.$router.push({path: '/requestQuotation'});
      //console.log("oId:", orderId);
    },

    goToHome() {
      this.$router.push({path: '/'});
    }
  }
}
</script>

<style scoped>
#mrequest{
  margin:4rem 0 8rem;
}

#mrequest h3{
  color:#111;
  font-weight: 700;
  font-size: 1.7rem;
  margin-bottom:2rem;
  text-align: center;
}

#mrequest .pc{
  display: block;
}
#mrequest .mobile{
  display: none;
}
@media (max-width:991px){
  #mrequest .pc{
    display: none;
  }
  #mrequest .mobile{
    display: block;
  }
}


/*--------------------------------------------------------------
	# 문의들 구분 탭
--------------------------------------------------------------*/
#mrequest .mr-tap{
  display: flex;
  max-width: 520px;
  margin: 0 auto 2.5rem;
  background: #f4f4f4;
  border-radius: 999px;
  padding: 4px;
}
#mrequest .mr-tap .tab-btn{
  flex: 1;
  padding: .75rem 0;
  background: transparent;
  color: #888;
  border: none;
  border-radius: 999px;
  font-size: .95rem;
  font-weight: 600;
  transition: all .18s ease;
}
#mrequest .mr-tap .tab-btn.active{
  background: #86cd53;
  color: #fff;
  box-shadow: 0 2px 8px rgba(134, 205, 83, .35);
}
#mrequest .mr-tap .tab-btn:not(.active):hover{
  color: #444;
}

@media (max-width:991px){
  #mrequest .mr-tap{
    margin: 0 auto 1.5rem;
    max-width: 100%;
  }
  #mrequest .mr-tap .tab-btn{
    font-size: .85rem;
    padding: .65rem 0;
  }
}


/*--------------------------------------------------------------
# 문의 내용 (PC 테이블)
--------------------------------------------------------------*/
#mrequest .mr-cont{
  margin:1.5rem 0
}
#mrequest .count-line{
  color:#999;
  font-size:.85rem;
  margin-bottom:.75rem;
}
#mrequest .count-line b{
  color:#333;
}
#mrequest .mr-cont .table{
  border-color:#eee;
  text-align: center;
  border-collapse: separate;
  border-spacing: 0;
}
#mrequest .mr-cont thead th{
  font-size:.85rem;
  font-weight:600;
  color:#888;
  padding:14px 0;
  background-color: #fafafa;
  border-bottom: 2px solid #eee;
}
#mrequest .mr-cont tbody td{
  font-size:.9rem;
  color:#333;
  padding: 16px 8px;
  border-bottom: 1px solid #f2f2f2;
  vertical-align: middle;
}
#mrequest .mr-cont tbody tr:hover{
  background-color: #fafcf8;
}
#mrequest .mr-cont .muted{
  color:#aaa;
  font-size:.85rem;
}
#mrequest .mr-cont .title-cell{
  text-align: left;
}
#mrequest .empty-row{
  color:#bbb;
  padding: 3rem 0;
  text-align: center;
  font-size: .9rem;
}

.row-link{
  color:#333;
  cursor:pointer;
  font-weight: 500;
  transition: color .15s ease;
}
.row-link:hover{
  color:#4f9c2b;
  text-decoration: underline;
}
.pdt-link{
  color:#6bab3e;
  cursor:pointer;
  font-size:.85rem;
}
.pdt-link:hover{
  text-decoration: underline;
}

.tag{
  display:inline-block;
  font-size:.78rem;
  color:#777;
  background:#f1f1f1;
  padding:.3rem .65rem;
  border-radius:6px;
}

.badge{
  display:inline-block;
  padding:.35rem .7rem;
  border-radius:999px;
  font-size:.78rem;
  font-weight:600;
  white-space:nowrap;
}
.badge-done{
  background:#eaf7e4;
  color:#4f9c2b;
}
.badge-wait{
  background:#f1f1f1;
  color:#999;
}


/*--------------------------------------------------------------
	# 모바일 카드
--------------------------------------------------------------*/
#mrequest .mobile{
  margin:1rem 0 0;
}
#mrequest .m-card{
  background:#fff;
  border:1px solid #eee;
  border-radius:12px;
  padding:1rem 1.1rem;
  margin-bottom:.85rem;
  box-shadow: 0 1px 6px rgba(0,0,0,.03);
}
#mrequest .m-card-top{
  display:flex;
  align-items:center;
  justify-content:space-between;
  margin-bottom:.6rem;
}
#mrequest .m-title{
  display:block;
  font-size:.98rem;
  font-weight:600;
  margin-bottom:.35rem;
}
#mrequest .m-pdt{
  display:block;
  margin-bottom:.35rem;
}
#mrequest .m-sub{
  font-size:.78rem;
  color:#aaa;
  margin:0;
}


/*--------------------------------------------------------------
# 버튼
--------------------------------------------------------------*/
#mrequest .go {
  padding:16px 0;
  background-color: #86cd53;
  color:#fff;
  border:none;
  border-radius:8px;
  font-weight:600;
  transition: background .15s ease;
}
#mrequest .go:hover{
  background-color: #74b845;
}
</style>